import { FEATURE_FLAGS_LOADED } from 'constants/reduxActions';
import { FeaturesAction } from 'actions/features';

export type FeaturesState = {
  [key: string]: string | number | boolean;
};

const initialState = {};

export default function featuresReducer(state: Readonly<FeaturesState> = initialState, action: FeaturesAction): FeaturesState {
  switch (action.type) {
    case FEATURE_FLAGS_LOADED:
      return {
        ...state,
        ...action.payload.features
      };
    default:
      return state;
  }
}
